import { Iconify } from '@sohanemon/utils/components';
import { m } from '@sohanscript/i18n';
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@sohanscript/ui/dialog';
import { Switch } from '@sohanscript/ui/switch';
import * as React from 'react';
import { Button } from '@/components/ui/button';
import { type DevMenuSettings, devMenuItems, setDevSetting } from './config';

interface DevMenuContentProps {
	defaultValues: DevMenuSettings;
	onClose: () => void;
}

export function DevMenuContent({
	defaultValues,
	onClose,
}: DevMenuContentProps) {
	const [values, setValues] = React.useState<DevMenuSettings>(defaultValues);

	const handleSubmit = () => {
		for (const key of Object.keys(values) as (keyof DevMenuSettings)[]) {
			setDevSetting(key, values[key]);
		}
		onClose();
	};

	return (
		<Dialog open onOpenChange={(open) => !open && onClose()}>
			<DialogContent className="max-w-md">
				<DialogHeader className="flex flex-row items-center gap-2 border-b pb-3">
					<Iconify icon="lucide:terminal" className="size-5" />
					<DialogTitle>{m.dev_menu_title()}</DialogTitle>
				</DialogHeader>
				<div className="space-y-4 py-4">
					{devMenuItems.map((item) => (
						<div
							key={item.id}
							className="flex items-start justify-between gap-4"
						>
							<div className="space-y-1">
								<p className="font-medium text-sm">{item.label()}</p>
								<p className="text-muted-foreground text-xs">
									{item.description()}
								</p>
							</div>
							<Switch
								checked={values[item.key]}
								onCheckedChange={(checked) =>
									setValues((prev) => ({ ...prev, [item.key]: checked }))
								}
							/>
						</div>
					))}
				</div>
				<div className="flex justify-end">
					<Button onClick={handleSubmit}>{m.dev_menu_save()}</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
}
